import searchIcon from 'assets/images/icons//how-it-works/lens.svg';
import filtersIcon from 'assets/images/icons//how-it-works/filters.svg';
import priceTagIcon from 'assets/images/icons//how-it-works/price-tag.svg';
import noCreditCardIcon from 'assets/images/icons//how-it-works/no-credit-card.svg';
import cursorIcon from 'assets/images/icons//how-it-works/cursor.svg';
import facilityIcon from 'assets/images/icons//how-it-works/facility.svg';
import { PaidTemplateHowItWorksIconList, formatPageType } from 'pages/PaidTemplatePage/constants';

export const storageList = (pageType) => {
	const textFirstItem = pageType === 'Self-Storage' ? pageType : formatPageType[pageType];
	const textLastItem = pageType === 'Self-Storage' ? 'into your unit' : `your ${formatPageType[pageType]} to your space`;

	return [
	{
		icon: searchIcon,
		text: `Search by address, city, or ZIP code for ${textFirstItem} storage`,
		alt: "searchIcon"
	},
	{
		icon: filtersIcon,
		text: 'Narrow your search by location, price, size or amenities',
		alt: "filterIcon"
	},
	{
		icon: priceTagIcon,
		text: `Find the best deal that meets your ${pageType === 'Self-Storage' ? '' : formatPageType[pageType]} storage needs`,
		alt: "priceTagIcon"
	},
	{
		icon: noCreditCardIcon,
		text: 'Make a risk-free reservation online, no credit card required',
		alt: "noCreditCardIcon"
	},
	{
		icon: cursorIcon,
		text: 'Complete your storage rental online, if available',
		alt: "cursorIcon"
	},
	{
		icon: PaidTemplateHowItWorksIconList[pageType] || facilityIcon,
		text: `Visit the storage facility and move ${textLastItem}`,
		alt: `facilityIcon-${pageType}`
	}
]};
